import * as React from 'react';
import { IconProps } from '../types';

const IcEven = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle cx={3.618} cy={8.309} r={3.118} fill={props?.fill ?? '#232F3E'} />
    <circle cx={21.382} cy={8.309} r={3.118} fill={props?.fill ?? '#232F3E'} />
    <path fill={props?.fill ?? '#232F3E'} d="M.5 11.428h24v1.475H.5z" />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="m12.5 12.902 2.931 4.43H9.57l2.931-4.43Z"
    />
  </svg>
);

export default IcEven;
